import { HttpParameterCodec } from '@angular/common/http';

// The default HttpParam Encoder will decode the '+' character (among others), after encoding.
// This custom encoder will not perform that step. (As the MediaHaven backend requires the + to be encoded as %2b).

export class CustomHttpParamEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
